import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import XLSX from 'xlsx'

import { httpOk, POST } from 'helpers/api'
import { formatMoney } from 'helpers/helpers'

function Index({ data, setData, modalNotInventored, setModalNotInventored }) {
	const { t } = useTranslation();

	const [annual, setAnnual] = useState(false)
	const [notInventoredProducts, setNotInventoredProducts] = useState([])

	function addToListMinusBalanceProducts() {
		var notInventoredProductsCopy = [...notInventoredProducts]
		var dataCopy = { ...data }

		var minusProducts = notInventoredProductsCopy.filter(element => element.balance < 0);
		dataCopy.elements = minusProducts

		setData(dataCopy)
		setModalNotInventored(false)
	}

	function addToListNotInventoredProduct(index) {
		var notInventoredProductsCopy = [...notInventoredProducts]
		var dataCopy = { ...data }

		dataCopy.elements.push(notInventoredProductsCopy[index])
		notInventoredProductsCopy.splice(index, 1)

		setNotInventoredProducts(notInventoredProductsCopy)

		if (notInventoredProductsCopy.length === 0) {
			setModalNotInventored(false)
		}
	}

	function addToListNotInventoredProducts() {
		var dataCopy = { ...data }
		var notInventoredProductsCopy = [...notInventoredProducts]

		dataCopy.elements = dataCopy.elements.concat(notInventoredProductsCopy)

		setData(dataCopy)
		setModalNotInventored(false)
	}

	function setActualBalanceModal(e, index) {
		var notInventoredProductsCopy = [...notInventoredProducts]
		notInventoredProductsCopy[index]['actual_balance'] = e.target.value
		setNotInventoredProducts(notInventoredProductsCopy)
	}

	function addToListSelectedProducts() {
		var notInventoredProductsCopy = [...notInventoredProducts]
		var dataCopy = { ...data }

		for (let i = 0; i < notInventoredProductsCopy.length; i++) {
			if (notInventoredProductsCopy[i]['selected']) {
				dataCopy.elements.push(notInventoredProductsCopy[i])
			}
		}

		setData(dataCopy)
		setModalNotInventored(false)
	}

	function markAsSelected(bool, index) {
		var notInventoredProductsCopy = [...notInventoredProducts]
		notInventoredProductsCopy[index]['selected'] = bool

		setNotInventoredProducts(notInventoredProductsCopy)
	}

	function sortBy(key, orderBy) {
		var notInventoredProductsCopy = [...notInventoredProducts]
		if (key === 'balance' && orderBy === 'asc') {
			notInventoredProductsCopy.sort((a, b) => parseFloat(a.balance) - parseFloat(b.balance));
		}
		if (key === 'balance' && orderBy === 'desc') {
			notInventoredProductsCopy.sort((a, b) => parseFloat(b.balance) - parseFloat(a.balance));
		}
		if (key === 'name' && orderBy === 'asc') {
			notInventoredProductsCopy.sort((a, b) => a.productName.localeCompare(b.productName))
		}
		if (key === 'name' && orderBy === 'desc') {
			notInventoredProductsCopy.sort((a, b) => b.productName.localeCompare(a.productName))
		}

		setNotInventoredProducts(notInventoredProductsCopy)
	}

	async function exportToExcel() {
		var excelHeaders = [[t('product_name'), t('price'), t('expected_balance')]]
		for (let i = 0; i < notInventoredProducts.length; i++) {
			var excelItems = []
			excelItems.push(notInventoredProducts[i]['name'])
			excelItems.push(notInventoredProducts[i]['price'])
			excelItems.push(notInventoredProducts[i]['balance'])
			excelHeaders.push(excelItems)
		}

		const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
		XLSX.writeFile(wb, t('not_inventored') + ".xlsx");
	}

	async function notInventoredList() {
		var arrayIds = []
		for (let i = 0; i < data.elements.length; i++) {
			arrayIds.push(data.elements[i]['element_id'])
		}
		var sendData = {
			"balance_ids": [],
			"pos_id": data.pos_id,
			"wms_id": data.wms_id
		}
		sendData.balance_ids = arrayIds

		const response = await POST('/inventory/not-inventored', sendData, { loader: true })
		if (httpOk(response)) {
			var list = [...response.data]
			for (let i = 0; i < list.length; i++) {
				list[i]['selected'] = false
				list[i]['actual_balance'] = list[i]['balance']
			}

			setNotInventoredProducts(list)
			setModalNotInventored(true)
		}
	}

	function annualActualBalance() {
		var notInventoredProductsCopy = [...notInventoredProducts]
		if (annual) {
			var selectedExist = false

			for (let i = 0; i < notInventoredProductsCopy.length; i++) {
				if (notInventoredProductsCopy[i]['selected']) {
					selectedExist = true
					break;
				}
			}

			if (selectedExist) {
				for (let i = 0; i < notInventoredProductsCopy.length; i++) {
					if (notInventoredProductsCopy[i]['selected']) {
						notInventoredProductsCopy[i]['actual_balance'] = 0
					}
				}
			} else {
				for (let i = 0; i < notInventoredProductsCopy.length; i++) {
					notInventoredProductsCopy[i]['actual_balance'] = 0
				}
			}
		} else {
			for (let i = 0; i < notInventoredProductsCopy.length; i++) {
				notInventoredProductsCopy[i]['actual_balance'] = notInventoredProductsCopy[i]['balance']
			}
		}

		setNotInventoredProducts(notInventoredProductsCopy)
	}

	function toggleModal(bool = false) {
		setNotInventoredProducts([])
		setModalNotInventored(bool)
	}

	useEffect(() => {
		annualActualBalance()
	}, [annual]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (modalNotInventored) notInventoredList()
	}, [modalNotInventored]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL NOT INVENTORED PRODUCTS */}
			<Modal show={modalNotInventored} animation={false} centered size="lg" backdrop="static"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						<div className="d-flex gap-2">
							<div className="me-4">{t('annual')}</div>
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input"
									defaultValue={false} onChange={(e) => setAnnual(e.target.checked)} />
							</div>
							<div>{t('sort_by')}</div>
							<button className="btn btn-sm btn-success" onClick={() => sortBy('balance', 'asc')}>[0-9]</button>
							<button className="btn btn-sm btn-success" onClick={() => sortBy('balance', 'desc')}>[9-0]</button>
							<button className="btn btn-sm btn-success" onClick={() => sortBy('name', 'asc')}>[A-Z]</button>
							<button className="btn btn-sm btn-success" onClick={() => sortBy('name', 'desc')}>[Z-A]</button>
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive inventory-modal-height">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th>#</th>
									<th style={{ 'width': '60%' }}>{t('name2')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('balance2')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('counted')}</th>
									<th style={{ 'minWidth': '33px' }} className="text-end"></th>
								</tr>
							</thead>
							<tbody>
								{notInventoredProducts.map((item, index) => (
									<tr key={index}>
										<td>
											<input type="checkbox"
												id={`control${index}`}
												onChange={(e) => markAsSelected(e.target.checked, index)} />
										</td>
										<td>{item.name}</td>
										<td className="text-end">{formatMoney(item.balance, 2)}</td>
										<td className="td-input">
											<input
												type="number"
												name="actual_balance"
												autoComplete="off"
												className="form-control text-end"
												placeholder="0"
												value={item.actual_balance ?? ''}
												onChange={(e) => setActualBalanceModal(e, index)} />
										</td>
										<td>
											<div className="table-action-button table-action-primary-button"
												onClick={() => addToListNotInventoredProduct(index)}>
												<i className="uil-plus"></i>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-secondary" tabIndex="-1"
						onClick={() => exportToExcel()}>
						EXCEL
					</button>
					<button className="btn btn-info" tabIndex="-1"
						onClick={() => addToListMinusBalanceProducts()}>
						{t('add_negative_balance')}
					</button>
					<button className="btn btn-success" tabIndex="-1"
						onClick={() => addToListSelectedProducts()}>
						{t('add_selected')}
					</button>
					<button className="btn btn-primary" tabIndex="-1"
						onClick={() => addToListNotInventoredProducts()}>
						{t('add_all')}
					</button>
				</Modal.Footer>
			</Modal>
			{/* MODAL NOT INVENTORED PRODUCTS */}
		</>
	)
}

export default Index